import { ref } from 'vue'

const alertMessage = ref('')
const alertType = ref('success') // could be 'success', 'error', etc.
const alertVisible = ref(false)

export function useGlobalAlert() {
  /**
   * Display an alert message with the given type.
   * Optionally auto-hide after 3 seconds.
   */
  const showAlert = (msg: string, type: string = 'success', autoHide: boolean = true) => {
    alertMessage.value = msg
    alertType.value = type
    alertVisible.value = true
    if (autoHide) {
      setTimeout(() => {
        alertVisible.value = false
      }, 3000)
    }
  }

  const hideAlert = () => {
    alertVisible.value = false
  }

  return { alertMessage, alertType, alertVisible, showAlert, hideAlert }
}
